module.exports = __webpack_public_path__ + "media/steps/loader_icon_3-e3eca18f.png";